var map = {
	"./vitality-money-Blue.svg": "6bd3",
	"./vitality-money-Bronze.svg": "7a76",
	"./vitality-money-Diamond.svg": "b09d",
	"./vitality-money-Gold.svg": "620f",
	"./vitality-money-Silver.svg": "a192"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8096";